import { Component, Input, OnInit, OnDestroy, NgZone, ViewChild, EventEmitter } from '@angular/core';

import { Subscription } from "rxjs";

import { ModalDirective } from "ngx-bootstrap/modal";

import { GlobalService, DeleteConfirmation } from './../index';

@Component({
    selector: 'delete-confirmation',
    templateUrl: './delete-confirmation.html',
    standalone: false
})
export class DeleteConfirmationComponent implements OnInit, OnDestroy {
    @ViewChild('deleteModal') modal: ModalDirective;
    public resultState: EventEmitter<boolean> = new EventEmitter<boolean>();

    public state: DeleteConfirmation = new DeleteConfirmation();
    public subscriptions: Subscription[] = [];

    constructor(
        private _globalService: GlobalService
    ) {
        this.subscriptions.push(this._globalService.beginDeleteConfirmation.subscribe((state: DeleteConfirmation) => {
            this.state = state;
            this.modal.show();
        }));
    }
    public confirm(): void {
        this.state.Confirmed = true;
        this._globalService.deleteResultEx.emit(this.state);
        this._globalService.deleteResult.emit(true);
        this.modal.hide();
    }

    public cancel(): void {
        this._globalService.deleteResultEx.emit(this.state);
        this._globalService.deleteResult.emit(false);
        this.modal.hide();
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}
